import { useEffect, useState } from "react";
import { useAdminCategoriesContext } from "../hooks/useAdminCategoriesContext";
import { useAuthContext } from "../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../utils/api";

import CategoryDetails from "../components/CategoryDetails";
import Drawer from "../components/Drawer/Drawer";
import CategoryForm from "../components/Froms/CategoryFrom/CategoryForm";
import Button from "../components/Button/Button";

const Categories = () => {
  const { categories, dispatch } = useAdminCategoriesContext();
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await apiFetch("/api/admin/categories", {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      const json = await response.json();

      if (response.ok) {
        dispatch({ type: "SET_CATEGORIES", payload: json });
      }
    };

    if (user) {
      fetchCategories();
    }
  }, [dispatch, user]);

  const handleCategoryClick = (categoryId) => {
    navigate(`/categories/${categoryId}`);
  };

  const openNewCategory = () => {
    setEditingCategory(null);
    setDrawerOpen(true);
  };

  const openEditCategory = (category) => {
    setEditingCategory(category);
    setDrawerOpen(true);
  };

  const closeDrawer = () => setDrawerOpen(false);

  return (
    <div className="categories-page">
      <div className="categories-page-header">
        <Button variant="secondary" onClick={openNewCategory}>
          New Category
        </Button>
      </div>

      <div>
        {categories &&
          categories.map((category) => (
            <div
              key={category._id}
              onClick={() => handleCategoryClick(category._id)}
              className="clickable"
            >
              <CategoryDetails category={category} onEdit={openEditCategory} />
            </div>
          ))}
      </div>

      <Drawer
        open={drawerOpen}
        onClose={closeDrawer}
        title={editingCategory ? "Edit Category" : "New Category"}
      >
        <CategoryForm
          key={editingCategory?._id ?? "new"}
          category={editingCategory}
          onSuccess={closeDrawer}
        />
      </Drawer>
    </div>
  );
};

export default Categories;
